<template>
  <b-modal
    ref="create-project-modal"
    :visible="show"
    class="pt-2"
    size="md"
    :title="title"
    ok-only
    :ok-title="$t('Accept')"
    :cancel-title="$t('Cancel')"
    @close="$emit('close')"
    @hide="$emit('close')"
  >
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent>
        <validation-provider
          #default="{ errors }"
          name="first name"
          rules="required"
        >
          <b-form-group :label="$t('Team Name')">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="FolderIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model="form.name"
                :placeholder="$t('Team Title')"
                :state="errors.length > 0 ? false : null"
              />
            </b-input-group>
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        <b-form-group :label="$t('Team Description')">
          <b-input-group class="input-group-merge">
            <b-form-textarea
              v-model="form.description"
              rows="8"
              :placeholder="$t('Team Description')"
            />
          </b-input-group>
        </b-form-group>
      </b-form>
    </validation-observer>
    <template #modal-footer="{ }">
      <b-row>
        <b-col
          md="12"
          class="d-flex justify-content-end"
        >
          <b-button
            variant="primary"
            :disabled="isProcessing"
            @click="handleOk"
          >
            <b-spinner
              v-show="isProcessing"
              small
            />
            <span v-if="form.id">
              {{ $t('Update') }}
            </span>
            <span v-else>
              {{ $t('Save') }}
            </span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import {
  BFormGroup, BFormInput, BForm, BInputGroup, BInputGroupPrepend, BFormTextarea, BButton, BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import useApollo from '@/plugins/graphql/useApollo'

const initialForm = () => ({
  id: null,
  name: '',
  description: '',
})

export default {
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BButton,
    BSpinner,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      title: this.$t('Create Team'),
      isProcessing: false,
      form: {
        ...initialForm(),
      },
    }
  },
  mounted() {
  },
  methods: {
    handleOk() {
      this.isProcessing = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const projectUid = this.$store?.state?.project?.selectedProject
          if (!projectUid) {
            this.showErrorMessage({ data: { message: 'No project selected. Please select a project and try again.' } })
            this.isProcessing = false
            return
          }

          useApollo.team.storeTeam({
            projectUid,
            name: this.form.name,
            description: this.form.description,
          }).then(() => {
            this.$emit('onSave')
            this.showSuccessMessage({
              data: {
                message: 'Team created',
              },
            })
            this.$emit('close')
          }).catch(error => {
            this.showErrorMessage(error)
          }).finally(() => { this.isProcessing = false })
        }
      })
    },
    handleUpdate(formData) {
      useApollo.project.updateproject(formData).then(response => {
        this.$emit('updateProjectList', response.data.updateproject, true)
        this.closeModal()
        this.showSuccessMessage({
          data: {
            message: 'Project successfully updated',
          },
        })
      }).catch(error => {
        this.showErrorMessage(error)
      }).finally(() => { this.isProcessing = false })
    },
  },

}
</script>
